export const bathroomRenoMaterials = [
  {
    groupName: 'Demolition & Prep Materials',
    materials: [
      { intent: 'Plastic sheeting (for dust containment)', quantity: 1 },
      { intent: 'Floor protection (Ram Board, drop cloths)', quantity: 1 },
      { intent: 'Heavy-duty contractor trash bags', quantity: 1 },
      { intent: 'Debris bin / haul-away service', quantity: 1 },
      { intent: 'Temporary wall zip poles or magnetic door seals (optional)', quantity: 1 }
    ]
  },
  {
    groupName: 'Plumbing Supplies',
    materials: [
      { intent: 'PEX, copper, or CPVC pipe (based on code/project)', quantity: 1 },
      { intent: 'Fittings (elbows, couplings, tees, etc.)', quantity: 1 },
      { intent: 'Shut-off valves', quantity: 1 },
      { intent: 'Toilet flange and wax ring / rubber gasket', quantity: 1 },
      { intent: 'Drain and trap assemblies (sink, shower, tub)', quantity: 1 },
      { intent: 'Shower/tub valve assembly', quantity: 1 },
      { intent: 'Supply lines (toilet and faucet)', quantity: 1 },
      { intent: 'Pipe insulation (if required)', quantity: 1 }
    ]
  },
  {
    groupName: 'Electrical Materials',
    materials: [
      { intent: 'GFCI outlets (as per code)', quantity: 1 },
      { intent: 'Light switches / dimmers', quantity: 1 },
      { intent: 'Lighting fixtures (vanity, ceiling, etc.)', quantity: 1 },
      { intent: 'Exhaust fan (w/ venting kit if needed)', quantity: 1 },
      { intent: 'NM cable (Romex 14/2 or 12/2 depending on load)', quantity: 1 },
      { intent: 'Electrical boxes (old or new work)', quantity: 1 }
    ]
  },
  {
    groupName: 'Framing & Subfloor Materials',
    materials: [
      { intent: 'Dimensional lumber', quantity: 1 },
      { intent: 'Plywood or OSB (for subfloor repair or replacement)', quantity: 1 }
    ]
  },
  {
    groupName: 'Wallboard & Wet-Area Surfaces',
    materials: [
      { intent: 'Waterproofing membrane', quantity: 1 },
      { intent: 'Cement board', quantity: 1 },
      { intent: 'Moisture-resistant drywall (green board)', quantity: 1 },
      { intent: 'Corner bead (if needed)', quantity: 1 },
      { intent: 'Joint compound', quantity: 1 },
      { intent: 'Drywall tape', quantity: 1 }
    ]
  },
  {
    groupName: 'Tiling & Flooring Materials',
    materials: [
      { intent: 'Floor tile & wall/shower tile', quantity: 1 },
      { intent: 'Tile backer board (if not already selected)', quantity: 1 },
      { intent: 'Thinset mortar (standard or rapid-set)', quantity: 1 },
      { intent: 'Grout (sanded or unsanded, depending on tile)', quantity: 1 },
      { intent: 'Grout sealer', quantity: 1 },
      { intent: 'Waterproofing membrane', quantity: 1 },
      { intent: 'Transition threshold', quantity: 1 }
    ]
  },
  {
    groupName: 'Fixtures',
    materials: [
      { intent: 'Toilet', quantity: 1 },
      { intent: 'Vanity and sink', quantity: 1 },
      { intent: 'Sink Faucet', quantity: 1 },
      { intent: 'Tub/Shower Faucet', quantity: 1 },
      { intent: 'Showerhead', quantity: 1 },
      { intent: 'Shower trim kit', quantity: 1 },
      { intent: 'Bathtub or shower base', quantity: 1 },
      { intent: 'Mirror or medicine cabinet', quantity: 1 },
      { intent: 'Towel bars', quantity: 1 },
      { intent: 'Robe hooks', quantity: 1 },
      { intent: 'Toilet paper holder', quantity: 1 }
    ]
  },
  {
    groupName: 'Paint & Trim Materials',
    materials: [
      { intent: 'Mold-resistant paint (ceiling & walls)', quantity: 1 },
      { intent: 'Paint Primer', quantity: 1 },
      { intent: 'Baseboards or other trim', quantity: 1 }
    ]
  },
  {
    groupName: 'Site wrap-up',
    materials: [
      { intent: 'Smoke/CO detectors (if required for final inspection)', quantity: 1 }
    ]
  },
  {
    groupName: 'Loadout List - Double Check Your Stock',
    materials: [
      { intent: 'Dust masks', quantity: 1 },
      { intent: 'Safety goggles (if replacements needed)', quantity: 1 },
      { intent: 'Reciprocating saw blades', quantity: 1 },
      { intent: 'Utility knife blades', quantity: 1 },
      { intent: 'Silicone sealant / plumber\'s putty', quantity: 1 },
      { intent: 'PVC primer and glue', quantity: 1 },
      { intent: 'Teflon tape', quantity: 1 },
      { intent: 'Construction adhesive', quantity: 1 },
      { intent: 'Shims / blocking materials', quantity: 1 },
      { intent: 'Screws or nails', quantity: 1 },
      { intent: 'Sandpaper blocks', quantity: 1 },
      { intent: 'Leveling clips/wedges', quantity: 1 },
      { intent: 'Tile spacers', quantity: 1 },
      { intent: 'Tile saw blade', quantity: 1 },
      { intent: 'Wire nut connectors', quantity: 1 },
      { intent: 'Electrical tape', quantity: 1 },
      { intent: 'Bucket', quantity: 1 },
      { intent: 'Sponges', quantity: 1 },
      { intent: 'Caulk (paintable latex for trim, silicone for wet areas)', quantity: 1 },
      { intent: 'New Paint brushes', quantity: 1 },
      { intent: 'Replacement Paint rollers', quantity: 1 },
      { intent: 'Paint trays or screens', quantity: 1 },
      { intent: 'Painters tape', quantity: 1 },
      { intent: 'Drop clothes', quantity: 1 },
      { intent: 'Shop vac filters (site cleanup)', quantity: 1 },
      { intent: 'Rags (site cleanup)', quantity: 1 },
      { intent: 'Cleaners (site cleanup)', quantity: 1 }
    ]
  }
];
